<template>
    <div class="header" ref="headerWrapper">
        <mu-appbar style="width: 100%;" color="primary" >
            <img :src="getImgUrl(seller.logo)"   height="50"  style="margin-top:5px;"  v-if="!isShowBack"/>
            <mu-button icon slot="left" @click="back" v-if="isShowBack">
                <mu-icon value="chevron_left" size="24" color="#fff" @click="back" ></mu-icon>
            </mu-button>

            <div class="nav-title" style="text-align:center;margin-left: 33%;width: 50px;">
                <img src="../assets/image/table.png" width="16" height="16" />
                <span style="font-size:14px;">{{tableOrderInfo.tableName}}</span>
                <!-- <span style="font-size:14px;margin-left:5px;color:#f44336" v-if="isSeft==1" class="notranslate">
                    <mu-icon value="access_alarms" size="16" @click="search" style="padding-top: 15px;" color="#fff"></mu-icon>
                    {{count}}
                </span> -->
            </div>

            <mu-menu slot="right" style="margin-right:0px;margin-top:16px;" class="notranslate">
                <mu-button fab small color="success" style="position:absolute;right:88px;" @click="openSelectLngDialog">
                    {{ selectLan }}
                </mu-button>

                <mu-button fab small color="teal" @click="callService">
                    <mu-icon value="notifications"></mu-icon>
                </mu-button>

                <mu-button fab small color="indigo" @click="openDrawer">
                    <mu-icon value="person"></mu-icon>
                </mu-button>
            </mu-menu>
        </mu-appbar>
        <mu-dialog :title="$t('header.selectLanguage')" width="360" scrollable :open.sync="openLng">
            <mu-list>
                <mu-list-item :key="option" v-for="option in lngOptions">
                    <mu-list-item-content>
                        <mu-radio :label="option" :value="option" v-model="selectLan"></mu-radio>
                    </mu-list-item-content>
                </mu-list-item>
            </mu-list>
            <mu-button slot="actions" flat color="primary" @click="closeSelectLngDialog">{{$t('common.ok')}}</mu-button>
        </mu-dialog>
        <mu-drawer :open.sync="open" :docked="docked" :right="true" width="100%">
            <div style="font-size: 20px; font-weight: 500;text-align: center;margin-top: 5px; ">{{$t('header.info')}}
            </div>
            <mu-icon value="close" size="30" class="close-icon" @click="closeInfo"></mu-icon>
            <mu-form :model="tableOrderInfo" class="mu-demo-form" label-position="top"
                style="width:90%;margin:0 auto;margin-top:10px;">
                <mu-form-item prop="Name" :label="$t('login.name')" style="margin-bottom:0px;">
                    <mu-text-field v-model="tableOrderInfo.name"></mu-text-field>
                </mu-form-item>
                <mu-form-item :label="$t('login.telephone')" prop="Telephone" style="margin-bottom:0px;">
                    <mu-text-field v-model="tableOrderInfo.telephone" prop="Telephone"></mu-text-field>
                </mu-form-item>

                <!--<mu-form-item label="Number" prop="Voksne" style="margin-bottom:0px;">
                <mu-select label="" v-model="tableOrderInfo.Voksne" full-width>
                    <mu-option v-for="option,index in options" :key="option" :label="option" :value="option"></mu-option>
                </mu-select>
            </mu-form-item>-->

            </mu-form>
            <div style="margin-top:20px;">


                <mu-row gutter>
      <mu-col span="6" style="padding:1px;">
        <div class="grid-cell" style="height: 120px; background-color: #9e9e9e; " @click="menuCartLink">
          <div class="link-btn">
            <mu-icon value="shopping_cart" style="color:#fff;"></mu-icon>
            <div class="text-content">
              <h4 class="title">{{$t('header.cartList')}}</h4>
              <div class="project-description">{{$t('header.cartListDsc')}}</div>
            </div>
          </div>
        </div>
      </mu-col>
      <mu-col span="6" style="padding:1px;">
        <div class="grid-cell" style="height: 120px; background-color: #9e9e9e; " @click="menuOrderLink">
          <div class="link-btn">
            <mu-icon value="receipt" style="color:#fff;"></mu-icon>
            <div class="text-content">
              <h4 class="title">{{$t('header.billList')}}</h4>
              <div class="project-description">{{$t('header.billListDsc')}}</div>
            </div>
          </div>
        </div>
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col span="6" style="padding:1px;">
        <div class="grid-cell" style="height: 120px; background-color: #9e9e9e; " @click="menuAddPackageLink">
          <div class="link-btn">
            <mu-icon value="add" style="color:#fff;"></mu-icon>
            <div class="text-content">
              <h4 class="title">{{$t('header.modify')}}</h4>
              <div class="project-description">{{$t('header.modifyDsc')}}</div>
            </div>
          </div>
        </div>
      </mu-col>
      <mu-col span="6" style="padding:1px;">
        <div class="grid-cell" style="height: 120px; background-color: #9e9e9e; " @click="callService">
          <div class="link-btn">
            <mu-icon value="headset" style="color:#fff;"></mu-icon>
            <div class="text-content">
              <h4 class="title">{{$t('header.artServices')}}</h4>
              <div class="project-description">{{$t('header.artServicesDsc')}}</div>
            </div>
          </div>
        </div>
      </mu-col>
    </mu-row>
              
            </div>
        </mu-drawer>
    </div>
</template>

<script>
    import { formatDate } from '../utils/formatDate';

    export default {
        props: {
            isSeft: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                seller: {},
                showFullScreen: true,
                docked: false,
                open: false,
                isShowBack: true,
                detailShow: false,
                curBusinessHours: '',
                tableOrderInfo: {},
                options: [
                    '1', '2', '3', '4',
                    '5', '6', '7', '8',
                    '9', '10', '11', '12', '13', '14',
                    '15', '16', '17', '18',
                    '19', '20'
                ],
                minutes: 120,
                seconds: 7200,
                count:"",
                openLng: false,
                selectLan:"EN",
                lngOptions: [
                    'DK',
                    'EN',
                    'PT',
                    '中文',
                ]
            }
        },
        methods: {
            getLanage() {
                if (localStorage.getItem('lang') != undefined && localStorage.getItem('lang') != null) {
                    this.$i18n.locale = localStorage.getItem('lang');
                    this.selectLan = localStorage.getItem('lang');
                    return localStorage.getItem('lang');
                }
                this.$i18n.locale = this.seller.language;
                return this.seller.language;
            },
            openSelectLngDialog() {
                this.openLng = true;
            },
            closeSelectLngDialog() {
                this.$i18n.locale = this.selectLan;
                localStorage.setItem('lang', this.selectLan);
                this.openLng = false;
            
            },
            openDrawer() {
                this.open = !this.open;
                this.docked = false;
            },
            closeInfo() {
                this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo, 7200000);
                this.open = false;
            },
            showDetail() {
                this.detailShow = true
            },
            hideDetail() {
                this.detailShow = false
            },
      
            jumpIndex() {
                this.open = false;
                this.docked = true;
                this.$router.push({
                    path: '/buffet'
                })
            }
            ,
            menuAddPackageLink() {
                this.open = false;
            //     this.docked = true;
            //     if(this.isSeft==0){
            //     this.$router.push({
            //         path: '/dinersNum',
            //         query: { modifyNum: 1 }
            //     })
            // }
            // else{
                this.$router.push({
                    path: '/buffetSelect'
                })
           // }

            },
            menuCartLink() {
                this.open = false;
                this.docked = true;
                this.$router.push({
                    path: '/cartList', query: {
                        packageType: 0,
                        isSeft: this.isSeft
                    }
                })
            },
            menuOrderLink() {
                this.open = false;
                this.docked = true;
                this.$router.push({
                    path: '/orderList', query: {
                        isSeft: this.isSeft
                    }
                })
            },
            menuBuffetLink() {
                this.open = false;
                this.docked = true;
                this.$router.push({
                    path: '/orderList', query: {
                        isSeft: 1
                    }
                })
            },
            back() {
                if (this.$route.path == '/buffet') {
                    this.$router.push({
                        path: '/buffet'
                    });
                }
                else if (this.$route.path == '/restaurant') {
                    this.$router.push({
                        path: '/buffet'
                    });
                }
                else if (this.$route.path == '/orderList') {
                    this.$router.push({
                        path: '/buffet'
                    });
                }
                else if (this.$route.path == '/cartList') {
                    this.$confirm(this.$t("header.continueText"), this.$t("header.confirmTips"), {
                        type: 'info',
                        okLabel: this.$t("common.ok"),
                        cancelLabel: this.$t("common.cancel")
                    }).then(({ result }) => {
                        if (result) {
                            this.$router.go(-1);
                        }
                    })
                }
                else {
                    this.$router.go(-1);
                }
            },
            getImgUrl(image, w = 0) {
            if (image == undefined || image == 'undefined' || image == null || image == '') {
                return '../static/img/default.png';
            }
            if (w == 0) {
                return this.global.baseUrl + "uploads/" + image
            }
            return this.global.baseUrl + "api/images/" + w + "/" + image
        },
            search() {
                this.$router.push({
                    path: '/search', query: {
                        isSeft: this.isSeft
                    }
                });
            },
            getOrderTime() {
                let param = {
                    tableName: this.tableOrderInfo.tableName,
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response.code == 200) {
                            var data = response.data;
                            if (data != undefined && data != null) {
                                let startTime = data.orderDay;
                                var dateDiff = new Date().getTime() -  new Date(startTime).getTime();
                               var sed=dateDiff/1000;
                               if(sed<7200 && sed>0){
                                this.seconds =sed;
                               }
                               else{
                                this.seconds =3600;
                               }
                            }
                        }
                    });
            },
            countDown() {
     let h = parseInt((this.seconds / (60 * 60)) % 24);
     h = h < 10 ? "0" + h : h;
     let m = parseInt((this.seconds / 60) % 60);
     m = m < 10 ? "0" + m : m;
     let s = parseInt(this.seconds % 60);
     s = s < 10 ? "0" + s : s;
     this.count = h + ":" + m + ":" + s;
   },
   tipTime(){
     this.countDown(); //解决刷新页面时，间隔一秒才会显示的问题
     setInterval(()=>{
       this.seconds-=1;
       this.countDown()
     },1000)
   },

            num: function (n) {
                return n < 10 ? '0' + n : '' + n
            },
            callService() {
                this.$confirm(this.$t("header.humanText"), this.$t("header.confirmTips"), {
                    type: 'message',
                    okLabel: this.$t("common.ok"),
                    cancelLabel: this.$t("common.cancel")
                }).then(({ result }) => {
                    if (result) {
                        let param = {
                            RestaurantId: this.tableOrderInfo.restaurantId,
                            OrderId: 0,
                            OrderNo: 0,
                            TableName: this.tableOrderInfo.tableName,
                        };
                        this.$post('QRCodeOrder/CallOrderService', param)
                            .then(response => {
                                if (response.code == 200) {
                                    this.$toast.success(this.$t(response.data));
                                    this.open = false;
                                } else {
                                    this.$toast.info(this.$t(response.data));
                                    this.open = false;
                                }
                            });
                    }
                })

            },
            initDate() {
                if (this.$route.path == '/buffet') {
                    this.isShowBack = false;
                }
                else {
                    this.isShowBack = true;
                }
            },

        },
        mounted() {
            if ("undefined" != typeof api) {
                this.showFullScreen = false;
            }
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.getOrderTime();
            this.initDate();
            this.getLanage();
            this.tipTime();
        },
     
        watch: {
            second: {
                handler(newVal) {
                    this.num(newVal)
                }
            },
            minute: {
                handler(newVal) {
                    this.num(newVal)
                }
            }
        },
        computed: {
            second: function () {
                return this.num(this.seconds)
            },
            minute: function () {
                return this.num(this.minutes)
            },

        },
        components: {

        },

    }
</script>

<style lang="stylus" rel="stylesheet/stylus">
.mu-appbar-title{
    display: flex;
    padding-left:0;
    padding-right:0;
}
    .header {
        overflow: hidden;
        position: relative;
        color: #fff;
        background-color: #FAFAFA;
        height: 56px;
    }

        .header .header-tip {
            width: 30px;
            position: absolute;
            top: 10px;
        }

        .header .header-search {
            width: 30px;
            position: absolute;
            top: 10px;
            left: 75%;
        }

        .header .header-cart {
            width: 30px;
            position: absolute;
            top: 10px;
            left: 87%;
        }

    .headerDivider {
        border-left: 1px solid #fff;
        height: 20px;
        position: absolute;
        top: 20px;
        padding-left: 5px;
        padding-right: 5px;
    }

    .shop {
        background: #fff;
        border-radius: 10px 10px 10px 10px;
        top: 50px;
        width: 94%;
        margin: 0 auto;
        position: absolute;
        display: block;
        left: 3%;
        z-index: 0;
        opacity: 0;
    }

    .flex-h {
        -webkit-box-orient: horizontal;
        -webkit-flex-flow: row;
        flex-flow: row;
    }

    .shop-header {
        padding: 10px 15px 0;
    }

    .ellipsis-1 {
        display: -webkit-box;
        white-space: normal !important;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .flex-1 {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
    }

    .shop-name {
        font-size: 16px;
        font-weight: 500;
        color: #616161;
    }

    .content-wrap {
        padding: 10px 15px;
    }

    .shop-address {
        width: 80%;
    }

    .shop-text {
        color: #666;
        font-size: 12px;
    }

    .shop-operation {
        border-top: 1px solid #eee;
    }

    .content-wrap {
        padding: 10px 15px;
    }

    .close-icon {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .link-btn .material-icons{color:#fff;}
    .link-btn {
        position: absolute;
        width: 100%;
        top: 8px;
        max-height: 100%;
        overflow: hidden;
        max-width: 100%;
        z-index: 999999;
        text-align: center;
    }

    h4.title {
        font-size: 18px;
        font-weight: normal;
        margin-bottom: 0;
        margin-top: 0;
        color: #fff;
        text-align:center;
    }

   .project-description {
        font-size: 13px;
        color: rgba(255,255,255,0.8);
        margin-top: 10px;
        margin-bottom: 15px;
    }
    .link-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
      }
      
      .text-content {
        text-align: center;
      }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue